import type { FC } from 'react';
// biome-ignore lint/style/useImportType: legacy import, will be migrated
import * as React from 'react';

type SmallBusinessLogoProps = {
  isSelected?: boolean;
};

const SmallBusinessLogo: FC<
  React.PropsWithChildren<SmallBusinessLogoProps>
> = ({ isSelected }) => {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 168 110"
      className="transition-all fill-current block"
      css={`
        color: ${isSelected ? 'var(--color-primary-light-400)' : '#b7bad5'};
        width: 107px;
        height: fit-content;
        @media (min-width: 768px) {
          width: 168px;
        }
        @media (min-width: 1024px) {
          width: 168px;
        }
      `}
    >
      <g
        clipPath="url(#a)"
        stroke="#33344F"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M132.742 66.647H41.715v44.064h91.027V66.647Z" fill="#fff" />
        <path
          d="M41.375 110.718c5.814 0 10.527-4.564 10.527-10.193 0-5.63-4.713-10.193-10.527-10.193-5.814 0-10.527 4.564-10.527 10.193s4.713 10.193 10.527 10.193ZM65.489 74.543c1.801 0 3.53.693 4.803 1.926a6.473 6.473 0 0 1 1.99 4.652v20.386H58.695V81.121c0-1.745.716-3.418 1.99-4.651a6.908 6.908 0 0 1 4.804-1.927v0ZM87.227 74.543c1.802 0 3.53.693 4.804 1.926a6.474 6.474 0 0 1 1.99 4.652v20.386H80.434V81.121c0-1.745.715-3.418 1.99-4.651a6.908 6.908 0 0 1 4.803-1.927v0ZM115.712 77.828a8.924 8.924 0 0 1 6.191 2.502 8.365 8.365 0 0 1 2.558 6.005v24.389h-17.535V86.335c0-2.254.925-4.416 2.571-6.01a8.926 8.926 0 0 1 6.208-2.49l.007-.007ZM137.158 58.096H37.301v8.55h99.857v-8.55ZM129.98 15.021H45.146c-.85 0-1.54.668-1.54 1.492v17.288c0 .824.69 1.492 1.54 1.492h84.834c.851 0 1.541-.668 1.541-1.492V16.513c0-.824-.69-1.492-1.541-1.492ZM137.158 58.095H37.301l8.83-16.44h82.197l8.83 16.44Z"
          fill="null"
        />
        <path d="M59.758 35.285v6.37M115.379 35.285v6.37" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h168v110H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SmallBusinessLogo;
